export default class User {
    constructor(email, password, firstName, lastName, roles, isEnterprise=false, organizationName, payCode) {
        this.email = email;
        this.password = password;
        this.firstName = firstName;
        this.lastName = lastName;
        this.roles = roles;
        this.isEnterprise = isEnterprise ? isEnterprise : false;
        this.organizationName = organizationName;
        this.payCode = payCode;
    }
}